export default __webpack_public_path__ + "static/media/EJeMq3-U0AA0N-w.01f753be.jpg";